module.exports = __webpack_public_path__ + "img/sw-logo-xl.9f1c6cd9.webp";